import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/header.css";
import "./css/style.css";
import "./css/responsive.css";
import Navbar from "./component/Nav.jsx";
import Banner from "./component/Banner.jsx";
import About from "./component/About.jsx";
import Mission from "./component/Mission.jsx";
import Subscription from "./component/Subscription.jsx";
import Journey from "./component/Journey.jsx";
import Why from "./component/Why.jsx";
import Faq from "./component/Faq.jsx";
import Contact from "./component/Contact.jsx";
import Footer from "./component/Footer.jsx";
import { useEffect } from "react";
import Whatsapp from "./component/Whatsapp.jsx";
import Form from "./component/Form.jsx";
import { FormProvider, useForm } from "./component/FormContext.jsx";
import Certification from "./component/Certification.jsx";
import Testimonial from "./component/Testimonial.jsx";
import TopSection from "./component/TopSection.jsx";

function AppContent() {
  const { isFormOpen, closeForm } = useForm();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 },
    );

    const hiddenElements = document.querySelectorAll(".animate");
    hiddenElements.forEach((el) => observer.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
  return (
    <>
      <Navbar />
      <Banner />
      <TopSection />
      <About />
      <Certification />
      <Mission />
      <Subscription />
      <Why />
      <Journey />
      <Faq />
      <Contact />
      <Testimonial />
      <Footer />
      <Whatsapp />
      <Form isOpen={isFormOpen} onClose={closeForm} />
    </>
  );
}

function App() {
  return (
    <FormProvider>
      <AppContent />
    </FormProvider>
  );
}

export default App;
